import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Row,
  Space,
  Tabs,
  Tag,
  Tooltip,
  Upload,
} from 'antd'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import DraggerUploadButton from '../../../components/Common/DraggerUploadButton'
import RichEditor from '../../../components/RichEditor/RichEditor'
import SelectGroupPopup from '../../../components/SelectGroupPopup/SelectGroupPopup'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup/SelectPeoplePopup'
import {
  ASSIGNEE_TYPE,
  DATE_FORMAT_LIST,
  WORK_STATUS,
} from '../../../constants'
import loadingAnimationStore from '../../../stores/loadingAnimationStore'
import utils from '../../../utils'
import { ButtonFooter } from '../PopupWorkForm/PopupWorkFormStyled'
import {
  SelectList,
  SelectTitle,
} from '../../MissionCreatePage/MissionCreatePageStyled'
import { blue, yellowPrimary } from '../../../color'
import { BankOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons'
import { AvatarHasName } from '../../../components/Common/Avatar'

const PopupElectronicReleaseFormV2 = props => {
  const {
    selectPeopleStore,
    workStore,
    fileStore,
    isOpenModal,
    setIsOpenModal,
  } = props

  const { workDetail, commentWorkList, groupVanThu } = workStore

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
  } = selectPeopleStore

  const [form] = Form.useForm()
  const EDITOR_REF = useRef()

  const [handlerList, setHandlerList] = useState([])
  const [followerList, setFollowerList] = useState([])
  const [electronicDocumentList, setElectronicDocumentList] = useState([])
  const [attachmentList, setAttachmentList] = useState([])
  const [attachments, setAttachments] = useState([])

  useEffect(() => {
    if (!isOpenModal) return
    const fileListFromComment = []
    commentWorkList &&
      commentWorkList.forEach(item => {
        if (!item.files || !Array.isArray(item.files)) return
        item.files.forEach(file => {
          fileListFromComment.push(file)
        })
      })
    const attachmentsDetail = workDetail.attachments || []
    setAttachments([...toJS(attachmentsDetail), ...toJS(fileListFromComment)])
  }, [isOpenModal, workDetail, commentWorkList])

  useEffect(() => {
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const onFinish = async value => {
    const code_work = workDetail?.code
    if (handlerList.length === 0) {
      return message.info('Bạn chưa chọn lãnh đạo ký duyệt.')
    }

    if (!followerList.some(item => item.id === groupVanThu?.id)) {
      return message.info('Người theo dõi bắt buộc phải có nhóm văn thư.')
    }

    const assigneesList = [...followerList, ...handlerList].map(el => ({
      assignee_code: el.id,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }))
    const electronicFile = electronicDocumentList.find(item => item.checked)
    let idElectronicFile
    if (!electronicFile.originFileObj) {
      idElectronicFile = electronicFile.file_id
    } else {
      try {
        loadingAnimationStore.showSpinner(true)
        const formDataElectronic = new FormData()
        formDataElectronic.append('file', electronicFile.originFileObj)
        const { data } = await fileStore.uploadFile(formDataElectronic)
        idElectronicFile = data.file_id
      } catch (err) {
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    }
    const attachmentData = attachmentList.filter(
      item => item.checked && !item.disabled
    )
    const attachmentUploaded = attachmentData
      .filter(item => !item.originFileObj)
      .map(item => item.file_id)
    const uploadAttachmentList = attachmentData
      .filter(item => item.originFileObj)
      .map(item => item.originFileObj)
    const batchUploadArr = []
    uploadAttachmentList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })
    try {
      loadingAnimationStore.showSpinner(true)
      const response = await Promise.all(batchUploadArr)
      const uploadedFiles = response.map(response => response.data.file_id)
      const dataSubmit = {
        ...value,
        electronic_id: undefined,
        attachments: [...attachmentUploaded, ...uploadedFiles],
        file_id: idElectronicFile,
        assignees: assigneesList,
        parent_id: code_work,
        content: EDITOR_REF?.current?.editor?.getData(),
        related_documents: [],
        work_type: WORK_STATUS.ELECTRONIC,
      }
      await workStore.createWork(dataSubmit)
      await workStore.getWorkDetail(code_work)
      message.success('Tạo công việc thành công!')
      handleCancel()
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  useEffect(() => {
    if (!isOpenModal) return
    setElectronicDocumentList(
      toJS(attachments)
        .filter(file =>
          ['pdf', 'doc', 'docx'].includes(
            utils.getExtensionFile(file.file_name)
          )
        )
        .map(item => ({
          ...item,
          checked: false,
        }))
    )
    setAttachmentList(
      toJS(attachments).map(item => ({
        ...item,
        disabled: false,
        checked: false,
      }))
    )
  }, [isOpenModal, attachments])

  useEffect(() => {
    if (!groupVanThu || !isOpenModal) return
    selectPeopleStore.setSelectGroupData({
      [ASSIGNEE_TYPE.HANDLER]: [],
      [ASSIGNEE_TYPE.COMBINER]: [],
      [ASSIGNEE_TYPE.FOLLOWER]: [
        {
          assignee_type: ASSIGNEE_TYPE.GROUP,
          full_name: groupVanThu.name,
          id: groupVanThu.id,
          permission: ASSIGNEE_TYPE.FOLLOWER,
        },
      ],
      [ASSIGNEE_TYPE.LEADER]: [],
    })
  }, [groupVanThu, isOpenModal])

  useEffect(() => {
    if (isOpenModal) {
      workStore.getGroupVanThu()
    }
  }, [isOpenModal])

  // Validate select electronic document
  useEffect(() => {
    if (!isOpenModal) return
    if (electronicDocumentList.length === 0) {
      form.setFieldsValue({
        electronic_id: undefined,
      })
      return
    }
    if (electronicDocumentList.some(item => item.checked)) {
      form.setFieldsValue({
        electronic_id: electronicDocumentList[0].file_id,
      })
    } else {
      form.setFieldsValue({
        electronic_id: undefined,
      })
    }
    const electronicDocumentChecked = electronicDocumentList.find(
      item => item.checked
    )
    const newAttachmentList = [...attachmentList].map(item => ({
      ...item,
      disabled: electronicDocumentChecked
        ? electronicDocumentChecked.file_id === item.file_id
        : false,
    }))
    setAttachmentList(newAttachmentList)
  }, [electronicDocumentList, isOpenModal])

  const handleChangeElectronicDoc = info => {
    const originElectronicList = toJS(attachments)
      .filter(file =>
        ['pdf', 'doc', 'docx'].includes(utils.getExtensionFile(file.file_name))
      )
      .map(item => ({
        ...item,
        checked: false,
      }))
    const newList = [
      {
        file_id: info.file.uid,
        file_name: info.file.name,
        checked: true,
        originFileObj: info.file,
      },
      ...originElectronicList,
    ]
    setElectronicDocumentList(newList)
  }

  const onChangeElectronicDocumentCheckBox = info => {
    const newList = [...electronicDocumentList].map(item => ({
      ...item,
      checked: false,
    }))
    const fileTarget = {
      ...newList.find(item => item.file_id === info.target.value),
      checked: info.target.checked,
    }
    const indexFileTarget = newList.findIndex(
      item => item.file_id === info.target.value
    )
    newList[indexFileTarget] = fileTarget
    setElectronicDocumentList(newList)
  }

  const handleCancel = () => {
    form.resetFields()
    selectPeopleStore.clearSelected()

    setElectronicDocumentList([])
    setAttachmentList([])
    setAttachments([])
    setFollowerList([])
    setHandlerList([])
    setIsOpenModal(false)
  }

  const handleChangeAttachment = info => {
    const newList = [
      ...info.fileList
        .map(item => ({
          file_id: item.uid,
          file_name: item.name,
          originFileObj: item.originFileObj,
          checked: true,
          disabled: false,
        }))
        .reverse(),
      ...attachmentList,
    ]
    const newAttachmentList = Array.from(
      new Set(newList.map(a => a.file_id))
    ).map(id => {
      return newList.find(a => a.file_id === id)
    })
    setAttachmentList(newAttachmentList)
  }

  const onChangeAttachmentCheckBox = info => {
    const newList = [...attachmentList]
    const fileTarget = {
      ...newList.find(item => item.file_id === info.target.value),
      checked: info.target.checked,
    }
    const indexFileTarget = newList.findIndex(
      item => item.file_id === info.target.value
    )
    newList[indexFileTarget] = fileTarget
    setAttachmentList(newList)
  }

  return (
    <Modal
      width={800}
      style={{ top: 40 }}
      title={'Phát hành văn bản điện tử'}
      visible={isOpenModal}
      maskClosable={false}
      onCancel={handleCancel}
      footer={null}
      wrapClassName="custom-modal-wrapper"
      destroyOnClose>
      <Form
        onFinish={onFinish}
        form={form}
        layout="vertical"
        initialValues={{
          title: 'Phát hành văn bản điện tử',
          start_date: moment(),
        }}>
        <Form.Item
          label={'Tiêu đề:'}
          name={'title'}
          rules={[
            { required: true, message: 'Vui lòng nhập tiêu đề' },
            { max: 500, message: 'Tiêu đề không được dài quá 500 ký tự!' },
          ]}>
          <Input disabled className="h-40" placeholder={'Nhập tiêu đề...'} />
        </Form.Item>

        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label={'Ngày bắt đầu:'}
              rules={[
                { required: true, message: 'Vui lòng chọn ngày bắt đầu!' },
              ]}
              name={'start_date'}>
              <DatePicker
                format={DATE_FORMAT_LIST}
                className="h-40"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={'Ngày kết thúc:'}
              name={'due_date'}
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const startDate = getFieldValue('start_date')
                    if (!startDate || !value) {
                      //! Không thực hiện kiểm tra nếu ngày bắt đầu hoặc ngày kết thúc không có giá trị
                      return Promise.resolve()
                    }
                    if (value.isAfter(startDate)) {
                      //! Ngày kết thúc lớn hơn ngày bắt đầu
                      return Promise.resolve()
                    }
                    //! Ngày kết thúc không hợp lệ
                    return Promise.reject(
                      'Ngày kết thúc phải lớn hơn ngày bắt đầu!'
                    )
                  },
                }),
              ]}>
              <DatePicker
                format={DATE_FORMAT_LIST}
                className="h-40"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <SelectTitle>
              <span>
                <span
                  style={{
                    color: '#ff4d4f',
                    fontFamily: 'SimSun, sans-serif',
                    marginRight: '-4px',
                  }}>
                  *{' '}
                </span>
                <span style={{ marginRight: '10px' }}>Lãnh đạo ký duyệt:</span>
              </span>
              <Space>
                <Tooltip title="Chọn người dùng" color={blue}>
                  <Button
                    className="select-user-icon-btn"
                    icon={<UserOutlined style={{ color: blue }} />}
                    onClick={() =>
                      handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.HANDLER)
                    }
                  />
                </Tooltip>
              </Space>
            </SelectTitle>
            <SelectList>
              {handlerList.map(el => (
                <Tag
                  className={'tag-selected'}
                  color={'blue'}
                  key={el.id}
                  closable
                  onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                  <AvatarHasName
                    imgId={el.image_id}
                    size={22}
                    name={el.full_name}
                    icon={
                      (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                        <BankOutlined />
                      )) ||
                      (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                        <TeamOutlined />
                      ))
                    }
                  />
                </Tag>
              ))}
            </SelectList>
          </Col>

          <Col span={12}>
            <SelectTitle>
              <span>
                <span
                  style={{
                    color: '#ff4d4f',
                    fontFamily: 'SimSun, sans-serif',
                    marginRight: '-4px',
                  }}>
                  *{' '}
                </span>
                <span style={{ marginRight: '10px' }}>Người theo dõi:</span>
              </span>
              <Space>
                <Tooltip title="Chọn người dùng" color={blue}>
                  <Button
                    className="select-user-icon-btn"
                    icon={<UserOutlined style={{ color: blue }} />}
                    onClick={() =>
                      handleOpenSelectUserDepartmentPopup(
                        ASSIGNEE_TYPE.FOLLOWER
                      )
                    }
                  />
                </Tooltip>
                <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                  <Button
                    className="select-user-icon-btn"
                    icon={<TeamOutlined />}
                    style={{ color: yellowPrimary }}
                    onClick={() =>
                      handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)
                    }
                  />
                </Tooltip>
              </Space>
            </SelectTitle>
            <SelectList>
              {followerList.map(el => (
                <Tag
                  className={'tag-selected'}
                  color={'blue'}
                  key={el.id}
                  closable
                  onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                  <AvatarHasName
                    imgId={el.image_id}
                    size={22}
                    name={el.full_name}
                    icon={
                      (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                        <BankOutlined />
                      )) ||
                      (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                        <TeamOutlined />
                      ))
                    }
                  />
                </Tag>
              ))}
            </SelectList>
          </Col>

          <Col span={24}>
            <Tabs defaultActiveKey="2" destroyInactiveTabPane={false}>
              <Tabs.TabPane tab="Nội dung" key="1" forceRender>
                <Form.Item label={'Nội dung:'} name={'content'}>
                  <RichEditor
                    EDITOR_REF={EDITOR_REF}
                    placeholder={'Nhập nội dung...'}
                    editorContent={''}
                  />
                </Form.Item>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Tài liệu trình ký" key="2" forceRender>
                <Form.Item
                  label={'Chọn file trình ký:'}
                  name={'electronic_id'}
                  rules={[
                    { required: true, message: 'Vui lòng chọn file trình ký!' },
                  ]}>
                  {
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <Upload.Dragger
                        accept={'.pdf,.docx,.docx'}
                        valuePropName={'fileList'}
                        fileList={electronicDocumentList}
                        onChange={handleChangeElectronicDoc}
                        showUploadList={false}
                        beforeUpload={() => false}
                        className="custom-dragger-upload">
                        <DraggerUploadButton acceptFileLabel="PDF, DOC, DOCX" />
                      </Upload.Dragger>
                      <Checkbox.Group
                        style={{ marginTop: 16 }}
                        value={
                          electronicDocumentList.find(item => item.checked)
                            ? electronicDocumentList.find(item => item.checked)
                                .file_id
                            : []
                        }>
                        <Space direction="vertical">
                          {electronicDocumentList.map(el => {
                            return (
                              <Checkbox
                                onChange={onChangeElectronicDocumentCheckBox}
                                key={el.file_id}
                                value={el.file_id}>
                                {el.file_name}
                              </Checkbox>
                            )
                          })}
                        </Space>
                      </Checkbox.Group>
                    </div>
                  }
                </Form.Item>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Tài liệu đính kèm" key="3" forceRender>
                <Form.Item label={'Chọn file đính kèm:'} name={'attachments'}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Upload.Dragger
                      multiple={true}
                      showUploadList={false}
                      valuePropName={'fileList'}
                      onChange={handleChangeAttachment}
                      beforeUpload={() => false}
                      className="custom-dragger-upload">
                      <DraggerUploadButton />
                    </Upload.Dragger>
                    <Checkbox.Group
                      style={{ marginTop: 16 }}
                      value={attachmentList
                        .filter(item => item.checked)
                        .map(item => item.file_id)}>
                      <Space direction="vertical">
                        {attachmentList.map(el => (
                          <Checkbox
                            onChange={onChangeAttachmentCheckBox}
                            key={el.file_id}
                            disabled={el.disabled}
                            value={el.file_id}>
                            {el.file_name}
                          </Checkbox>
                        ))}
                      </Space>
                    </Checkbox.Group>
                  </div>
                </Form.Item>
              </Tabs.TabPane>
            </Tabs>
          </Col>
        </Row>

        <ButtonFooter>
          <Space>
            <Button className="custom-ant-button" danger onClick={handleCancel}>
              Hủy
            </Button>
            <Button
              className="custom-ant-button"
              type={'primary'}
              htmlType={'submit'}>
              Tạo mới
            </Button>
          </Space>
        </ButtonFooter>
      </Form>
      <SelectPeoplePopup
        onlyOneUser={
          selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.HANDLER
        }
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
      <SelectGroupPopup
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      />
    </Modal>
  )
}

export default inject(
  'selectPeopleStore',
  'workStore',
  'fileStore'
)(observer(PopupElectronicReleaseFormV2))
